import { Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { styles } from '../../styles';
import logo from '../../assets/logo/logo.webp';

export default function FooterComponent() {
  const year = dayjs(new Date()).format('YYYY');

  return (
    <>
      <Row gutter={24} style={{ ...styles.flexDisplay, marginBottom: '10px' }}>
        <Col span={20}>
          <Typography.Text style={{ color: '#fff' }}>
            Disclaimer: Koostream publishes sports fixtures, schedules, standings, and original
            editorial content. We do not host copyrighted broadcasts. League, team, and event names
            are trademarks of their owners and are used for identification and news reporting.
            Third-party websites linked from this site are not controlled by Koostream. Report alleged
            infringement through our <Link to="/dmca">DMCA Policy</Link>.
          </Typography.Text>
        </Col>
      </Row>
      <Row gutter={24} style={styles.flexDisplay}>
        <Col xs={24} sm={4} style={{ marginBottom: '8px' }}>
          <img src={logo} className="logo-img" alt="Koostream logo" />
        </Col>
        <Col xs={12} sm={3}>
          <Link to="/about">
            <Typography.Text style={{ color: '#fff' }}>About</Typography.Text>
          </Link>
        </Col>
        <Col xs={12} sm={3}>
          <Link to="/blogs">
            <Typography.Text style={{ color: '#fff' }}>Blog</Typography.Text>
          </Link>
        </Col>
        <Col xs={12} sm={3}>
          <Link to="/privacy-policy">
            <Typography.Text style={{ color: '#fff' }}>Privacy</Typography.Text>
          </Link>
        </Col>
        <Col xs={12} sm={3}>
          <Link to="/terms">
            <Typography.Text style={{ color: '#fff' }}>Terms</Typography.Text>
          </Link>
        </Col>
        <Col xs={12} sm={3}>
          <Link to="/dmca">
            <Typography.Text style={{ color: '#fff' }}>DMCA</Typography.Text>
          </Link>
        </Col>
        <Col xs={12} sm={3}>
          <Link to="/contact-us">
            <Typography.Text style={{ color: '#fff' }}>Contact</Typography.Text>
          </Link>
        </Col>
      </Row>
      <Row style={{ ...styles.flexDisplay, marginTop: '10px' }}>
        <Typography.Text style={{ color: '#fff' }}>
          © {year} Koostream. All rights reserved. Not affiliated with any professional league or
          broadcaster.
        </Typography.Text>
      </Row>
    </>
  );
}
